import React from "react";

interface PhoneError {
  phone: string;
  status: string;
}

interface PhoneErrorModalProps {
  show: boolean;
  errors: PhoneError[];
  onClose: () => void;
}

/**
 * Displays phone numbers that could not be added with their error reasons.
 * Shown after add/upload operations return validation errors.
 */
const PhoneErrorModal: React.FC<PhoneErrorModalProps> = ({
  show,
  errors,
  onClose,
}) => {
  if (!show) return null;

  return (
    <div
      className="modal d-block"
      tabIndex={-1}
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header bg-danger text-white">
            <h5 className="modal-title">
              Phone number(s) not added to monitoring list
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onClose}
            />
          </div>
          <div className="modal-body">
            {errors.length === 0 ? (
              <p className="text-muted">No errors to display.</p>
            ) : (
              <table className="table table-sm table-striped">
                <thead>
                  <tr>
                    <th>Phone Number</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {errors.map((err, i) => (
                    <tr key={i}>
                      <td>{err.phone}</td>
                      <td>{err.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhoneErrorModal;
